import type { ThreadMessageLike } from "@assistant-ui/react";

/** Key under `metadata.custom` holding the backend message id (written by history + transport). */
export const MESSAGE_BACKEND_ID_KEY = "backendId";

/**
 * Key under `metadata.custom` holding the raw sub-agent names a live turn routed to. Written only
 * by the streaming transport, so its absence means the message was loaded from history.
 */
export const MESSAGE_SUB_AGENTS_KEY = "subAgents";

interface MetadataCarrier {
  metadata?: Pick<NonNullable<ThreadMessageLike["metadata"]>, "custom">;
}

/** Backend message id recorded in custom metadata, or undefined when unknown. */
export function getBackendMessageId(
  message: MetadataCarrier | undefined | null,
): string | undefined {
  const id = message?.metadata?.custom?.[MESSAGE_BACKEND_ID_KEY];
  return typeof id === "string" && id ? id : undefined;
}

/**
 * Sub-agents recorded on a live-streamed message (possibly empty), or undefined for a message
 * loaded from history, which carries no routing info.
 */
export function getMessageSubAgents(
  message: MetadataCarrier | undefined | null,
): string[] | undefined {
  const value = message?.metadata?.custom?.[MESSAGE_SUB_AGENTS_KEY];
  return Array.isArray(value) ? value.filter((v): v is string => typeof v === "string") : undefined;
}
